export default __webpack_public_path__ + "static/media/2223 spice rack top.283f1f55.png";